import { Button, useDisclosure } from '@nextui-org/react-latest'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'
import dynamic from 'next/dynamic'

const ConnectWithUsModal = dynamic(
  () => import('@components/organisms/ConnectWithUsModal'),
  { ssr: false }
)

type Props = {}

const MigrateCourse = ({}: Props) => {
  const { isOpen, onOpenChange, onOpen } = useDisclosure()
  const { t } = useTranslation('resources/migrateCourses')
  return (
    <div className="w-full max-w-7xl mx-auto px-4 pt-14 pb-20">
      <div className="bg-[#F7F8FF] sm:mx-0 rounded-3xl overflow-hidden px-8 py-[99px] text-center relative">
        <Image
          src="/static/images/features/line-bg.png"
          unoptimized={true}
          layout="responsive"
          width={1000}
          height={500}
          alt="Line background"
          className="absolute bottom-0 left-0"
        />
        <h2 className="text-4xl sm:text-5xl md:text-[64px] font-bold text-uguPurple mb-10">
          {t('migrationSupport.title')}
        </h2>

        <p className="text-xl sm:text-2xl font-medium text-uguPurple mb-16 max-w-[965px] mx-auto">
          {t('migrationSupport.description')}
        </p>

        <Button
          radius="full"
          className="font-medium px-9 py-7"
          size="lg"
          color="primary"
          onPress={onOpen}
        >
          {t('migrationSupport.buttonText')}
        </Button>
      </div>
      {isOpen && (
        <ConnectWithUsModal isOpen={isOpen} onOpenChange={onOpenChange} />
      )}
    </div>
  )
}

export default MigrateCourse
